import React, { useEffect, useState } from "react";
import PasajeroFormulario from "./PasajeroFormulario";

import { toolsAPI, listaNegraAPI } from "../../../utils/funcionesAPI";
import {
  manejadorDeRespuesta,
  calcularEdad,
  validateCUITorCUIL,
} from "../../../utils/Tools";
import PropTypes from "prop-types";
import LoaderFormal from "../../Global/LoaderFormal";
import { toast } from "react-toastify";
import DatosDeFacturacion from "../../Global/DatosDeFacturacion";

const CargaPasajeros = (props) => {
  const [tiposDocumento, setTiposDocumento] = useState([]);
  const [nacionalidades, setNacionalidades] = useState([]);
  const [loaded, setLoaded] = useState(true);

  const formularioDefault = {
    id: 0,
    responsabilidad: "",
    tipoDocumento: { sigla: "" },
    numeroDocumento: "",
    factura: "",
    razonSocial: "",
    calle: "",
    altura: "",
    codigoPostal: "",
    provincia: { id: 2, codigo: "ARC", denominacion: "Capital Federal" },
    localidad: { id: "5001", denominacion: "Ciudad Autónoma De Buenos Aires" },
    mail: "",
    propia: 1,
  };

  /*Logica nueva para datos de facturacion*/
  const [formulario, setFormulario] = useState(formularioDefault);
  const [mostrarDatosDeFacturacion, setMostrarDatosDeFacturacion] =
    useState("false");
  const [formularioSeleccionado, setFormularioSeleccionado] = useState({
    id: 0,
    provincia: { id: 2, codigo: "ARC", denominacion: "Capital Federal" },
  });

  /*fin logica nueva*/

  let { busqueda, pasajerosAdultos, pasajerosMenores } = props;
  const tipoCliente = sessionStorage.getItem("tipoCliente");

  useEffect(() => {
    window.scrollTo(0, 0);

    let data = JSON.stringify({ accion: "tiposDeDocumento" });
    toolsAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta))
        setTiposDocumento(respuesta.data);
    });

    data = JSON.stringify({ accion: "paises" });
    toolsAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta))
        setNacionalidades(respuesta.data);
      setLoaded(false);
    });
  }, []);

  const handlePasajeroAdultoChange = (indice, propiedad, valor) => {
    props.onPasajeroAdultoChange(indice, propiedad, valor);
  };

  const handlePasajeroMenorChange = (indice, propiedad, valor) => {
    props.onPasajeroMenorChange(indice, propiedad, valor);
  };

  async function handlePasoPagarClick(e) {
    e.preventDefault();

    if (
      !validarDatosCompletos(props.pasajerosAdultos) ||
      !validarDatosCompletos(props.pasajerosMenores)
    ) {
      toast.error("Debe completar todos los campos de los pasajeros", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }

    if (!validarEdadAdultos(props.pasajerosAdultos)) {
      toast.error("Los adultos deben ser mayores de 2 años", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }

    if (!validarEdadMenores(props.pasajerosMenores)) {
      toast.error(
        "No coincide la edad del menor declarada con la fecha de nacimiento",
        {
          position: toast.POSITION.BOTTOM_CENTER,
        }
      );
      return;
    }

    /*
    if (
      tipoCliente === "IND" &&
      mostrarDatosDeFacturacion === "true" &&
      mostrarListadoDeDatosDeFacturacionPrevios === "true" &&
      !formularioSeleccionado.id
    ) {
      toast.error(
        "No ha seleccionado un dato de facturacion.",
        {
          position: toast.POSITION.BOTTOM_CENTER,
        }
      );
      return;
    }
      */

    if (
      tipoCliente === "IND" &&
      mostrarDatosDeFacturacion === "true" &&
      !validarDatosDeFacturacion(formulario)
    ) {
      return;
    }

    const resultadoValidacionListaNegra = await validarSiEstaEnListaNegra(
      props.pasajerosAdultos
    );
    if (resultadoValidacionListaNegra !== true) {
      toast.error(resultadoValidacionListaNegra, {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }

    if (tipoCliente === "IND" && mostrarDatosDeFacturacion === "true") {
      sessionStorage.setItem("datosDeFacturacion", JSON.stringify(formulario));
    } else {
      sessionStorage.setItem("datosDeFacturacion", null);
    }

    props.onPasoPagarClick();
  };

  const validarDatosCompletos = (pasajeros) => {
    let rto = true;
    pasajeros.forEach(function (unPasajero) {
      for (var key in unPasajero) {
        if (
          !unPasajero.hasOwnProperty("nombre") ||
          !unPasajero.hasOwnProperty("apellido") ||
          !unPasajero.hasOwnProperty("telefono") ||
          !unPasajero.hasOwnProperty("fechaNacimiento") ||
          !unPasajero.hasOwnProperty("documento") ||
          !unPasajero.hasOwnProperty("tipoDocumento")
        ) {
          rto = false;
        }

        if (
          (key === "nombre" && unPasajero[key] === "") ||
          (key === "apellido" && unPasajero[key] === "") ||
          (key === "telefono" && unPasajero[key] === "") ||
          (key === "fechaNacimiento" && unPasajero[key] === "") ||
          (key === "documento" && unPasajero[key] === "")
        ) {
          rto = false;
        }
      }
    });
    return rto;
  };

  const validarEdadMenores = (pasajeros) => {
    let rto = true;
    pasajeros.forEach(function (unPasajero) {
      let edad = calcularEdad(unPasajero.fechaNacimiento);
      if (Number(unPasajero.edad) !== edad) {
        rto = false;
      }
    });
    return rto;
  };

  const validarEdadAdultos = (pasajeros) => {
    let rto = true;
    pasajeros.forEach(function (unPasajero) {
      let edad = calcularEdad(unPasajero.fechaNacimiento);
      if (edad < 2) {
        rto = false;
      }
    });
    return rto;
  };

  async function validarSiEstaEnListaNegra(pasajeros) {
    try {
      const data = JSON.stringify({ peticion: 5, pasajeros });
      const respuesta = await listaNegraAPI(data);

      if (respuesta && respuesta.data === true) return true;
      if (respuesta && respuesta.mensaje) return respuesta.mensaje;

      return 'Ha ocurrido un error';
    } catch (error) {
      return error.message;
    }
  }

  const validarDatosDeFacturacion = (formFacturacion) => {
    if (
      formFacturacion.razonSocial === "" ||
      !formFacturacion.razonSocial ||
      formFacturacion.mail === "" ||
      formFacturacion.calle === "" ||
      formFacturacion.altura === "" ||
      formFacturacion.codigoPostal === "" ||
      formFacturacion.provincia.id === 0 ||
      formFacturacion.localidad.id === 0 ||
      formFacturacion.numeroDocumento === "" ||
      formFacturacion.factura === "" ||
      formFacturacion.tipoDocumento.sigla === "" ||
      formFacturacion.responsabilidad === "" ||
      formFacturacion.responsabilidad === "0"
    ) {
      toast.info("Debe completar todos los campos de facturacion", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return false;
    }
    if (formFacturacion.calle.length < 5) {
      toast.info("La calle debe tener al menos 5 caracteres", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return false;
    }
    if (formFacturacion.razonSocial.trim().length < 2) {
      toast.info("Debe escribir al menos 2 caracteres para la Razon Social", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return false;
    }
    if (
      formFacturacion.tipoDocumento.sigla === "CUIT" ||
      formFacturacion.tipoDocumento.sigla === "CUIL"
    ) {
      if (!validateCUITorCUIL(formFacturacion.numeroDocumento)) {
        toast.info("El numero de CUIT/CUIL no es correcto", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        return false;
      }
    }

    return true;
  };

  // render() {

  //let producto = JSON.parse(sessionStorage.getItem('producto'));
  //producto.charters = [];
  //  const charter = JSON.parse(sessionStorage.getItem('charter'));

  return (
    <div className="">
      <LoaderFormal loaded={loaded} />
      <div className="title">
        <h2>Datos de los pasajeros </h2>
        <p>
          <sup>*</sup> Datos obligatorios
        </p>
        <hr />
      </div>
      <p className="parrafoCargaPasajeros">
        Pasajeros: {pasajerosAdultos.length} Adultos y {pasajerosMenores.length}{" "}
        Menores. Para cambiar la cantidad de pasajeros, realice una nueva
        busqueda desde el paso previo
      </p>
      {pasajerosAdultos.map((pasajero, clave) => {
        return (
          <PasajeroFormulario
            key={clave}
            numero={clave}
            busqueda={busqueda}
            pasajero={pasajero}
            onPasajeroChange={handlePasajeroAdultoChange}
            tiposDeDocumento={tiposDocumento}
            nacionalidades={nacionalidades}
          />
        );
      })}

      {pasajerosMenores.map((pasajero, clave) => {
        return (
          <PasajeroFormulario
            key={clave}
            numero={clave}
            busqueda={busqueda}
            pasajero={pasajero}
            onPasajeroChange={handlePasajeroMenorChange}
            tiposDeDocumento={tiposDocumento}
            nacionalidades={nacionalidades}
          />
        );
      })}

      {tipoCliente === "IND" && (
        <DatosDeFacturacion
          formularioDefault={formularioDefault}
          formulario={formulario}
          setFormulario={setFormulario}
          mostrarDatosDeFacturacion={mostrarDatosDeFacturacion}
          setMostrarDatosDeFacturacion={setMostrarDatosDeFacturacion}
          formularioSeleccionado={formularioSeleccionado}
          setFormularioSeleccionado={setFormularioSeleccionado}
        />
      )}

      <input
        type="submit"
        value="continuar"
        className="submitCargaPasajeros"
        onClick={handlePasoPagarClick}
      />
    </div>
  );
};

export default CargaPasajeros;

CargaPasajeros.propTypes = {
  busqueda: PropTypes.object,
  pasajerosAdultos: PropTypes.array,
  pasajerosMenores: PropTypes.array,
  producto: PropTypes.object,
  charter: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/components/ProcesoCompra/CargaPasajeros/index.js